import {
    browserName,
    browserVersion,
    engineName,
    engineVersion,
    isIOS,
    isMobile,
    isTablet,
    mobileModel,
    mobileVendor,
    osName,
    osVersion,
} from 'react-device-detect';

export const userDevice = () => {
    let device = 'Desktop';
    if (isMobile) device = 'Mobile';
    if (isTablet) device = 'Tablet';

    return JSON.stringify({
        device: device,
        mobileVendor: mobileVendor,
        mobileModel: mobileModel,
        osName: osName,
        osVersion: osVersion,
        browserName: browserName,
        browserVersion: browserVersion,
        engineName: engineName,
        engineVersion: engineVersion,
    });
};
